export default "__VITE_ASSET__mU1NHZrL__"